import { catering, dailyMeals, menu } from "./constants";

export const SCHOOL_LOCALHOST = 'localhost';
export const SCHOOL_DEMO = 'demo';

export const SCHOOL_ATH_GYM_ATH = 'athensCollegeGymAthens'; // Gymnasium Athens College email: acms@athenscollege.edu.gr
export const SCHOOL_ATH_GYM_PSY = 'athensCollegeGymPsychico'; // Gymnasium Athens College Psychico email: gympc@athenscollege.edu.gr
export const SCHOOL_ATH_SEC = 'athensCollegeSecondary'; // Lykeio Athens College
export const SCHOOL_STC_LOWER = 'stcl'; // St. Catherine's British School up to dimotiko
export const SCHOOL_STC_UPPER = 'stcu'; // St. Catherine's British School gym and lykeio
export const SCHOOL_STC_SUMMER_CAMP_1 = 'stcsc1'; // St. Catherine's British School Summer Fest
export const SCHOOL_STC_SUMMER_CAMP_2 = 'stcsc2'; // St. Catherine's British School Sports Camp
export const SCHOOL_ACS_LOWER = 'acsl'; // American Community School Lower
export const SCHOOL_ACS_UPPER = 'acsu'; // American Community School Upper
export const SCHOOL_CAMPION = 'campion'; // Campion School
export const SCHOOL_MORAITIS_LOWER = 'moraitis-l'; // Moraitis School Lower
export const SCHOOL_MORAITIS_UPPER = 'moraitis-u'; // Moraitis School Upper
export const SCHOOL_DES_PRIM = 'desPrimary';
export const SCHOOL_ALL_SCHOOLS = 'all_schools';

const subDomainDemo = 'demo.lunch-box.gr';


// const subDomainAthensCollegePrimaryAthens = 'athenscollege-demac.lunch-box.gr';
// const subDomainAthensCollegePrimaryPsychico = 'athenscollege-dempc.lunch-box.gr';
const subDomainAC = 'ac.lunch-box.gr'; // Athens College (all)
const subDomainAthensCollegeGymAthens = 'acms.lunch-box.gr';
const subDomainAthensCollegeGymPsychico = 'gympc.lunch-box.gr';
const subDomainAthensCollegeSecondary = 'achs.lunch-box.gr';

const subDomainStc = 'stc.lunch-box.gr'; // St. Catherine's British School (all)
const subDomainStcLower = 'stcl.lunch-box.gr';
const subDomainStcUpper = 'stcu.lunch-box.gr';
const subDomainStcSummerCamp1 = 'stcsc1.lunch-box.gr';
const subDomainStcSummerCamp2 = 'stcsc2.lunch-box.gr';

const subDomainACS = 'acs.lunch-box.gr';
const subDomainACSLower = 'acsl.lunch-box.gr';
const subDomainACSUpper = 'acsu.lunch-box.gr';

const subDomainCampion = 'campion.lunch-box.gr';

const subDomainMoraitis = 'moraitis.lunch-box.gr';
const subDomainMoraitisLower = 'moraitis-l.lunch-box.gr';
const subDomainMoraitisUpper = 'moraitis-u.lunch-box.gr';

const subDomainDesPrimary = 'des-primary.lunch-box.gr';

export const mainDbInstanceName = 'lunchbox-main';

export const dbKeyMap: Record<string, string> = {
    [SCHOOL_LOCALHOST]: 'localhost',
    [SCHOOL_DEMO]: subDomainDemo,
    [SCHOOL_ATH_GYM_ATH]: subDomainAthensCollegeGymAthens,
    [SCHOOL_ATH_GYM_PSY]: subDomainAthensCollegeGymPsychico,
    [SCHOOL_ATH_SEC]: subDomainAthensCollegeSecondary,
    [SCHOOL_STC_LOWER]: subDomainStcLower,
    [SCHOOL_STC_UPPER]: subDomainStcUpper,
    [SCHOOL_STC_SUMMER_CAMP_1]: subDomainStcSummerCamp1,
    [SCHOOL_STC_SUMMER_CAMP_2]: subDomainStcSummerCamp2,
    [SCHOOL_ACS_LOWER]: subDomainACSLower,
    [SCHOOL_ACS_UPPER]: subDomainACSUpper,
    [SCHOOL_CAMPION]: subDomainCampion,
    [SCHOOL_MORAITIS_LOWER]: subDomainMoraitisLower,
    [SCHOOL_MORAITIS_UPPER]: subDomainMoraitisUpper,
    [SCHOOL_DES_PRIM]: subDomainDesPrimary
}

export const cateringMap: Record<string, string> = {
    [SCHOOL_LOCALHOST]: catering.Demo,
    [SCHOOL_DEMO]: catering.Demo,
    [SCHOOL_ACS_LOWER]: catering.Gefsinus,
    [SCHOOL_ACS_UPPER]: catering.Gefsinus,
    [SCHOOL_ATH_GYM_ATH]: catering.Gefsinus,
    [SCHOOL_ATH_GYM_PSY]: catering.Gefsinus,
    [SCHOOL_ATH_SEC]: catering.Gefsinus,
    [SCHOOL_STC_LOWER]: catering.Gefsinus,
    [SCHOOL_STC_UPPER]: catering.Gefsinus,
    [SCHOOL_STC_SUMMER_CAMP_1]: catering.Gefsinus,
    [SCHOOL_STC_SUMMER_CAMP_2]: catering.Gefsinus,
    [SCHOOL_CAMPION]: catering.Gefsinus,
    [SCHOOL_MORAITIS_LOWER]: catering.Gefsinus,
    [SCHOOL_MORAITIS_UPPER]: catering.Gefsinus,
    [SCHOOL_DES_PRIM]: catering.Demo,
    default: catering.Demo
}

// Menu mapping - allows different schools to have different menus
// while keeping the same catering for meals and snacks
export const menuMap: Record<string, string> = {
    [SCHOOL_LOCALHOST]: menu.Demo,
    [SCHOOL_DEMO]: menu.Demo,
    [SCHOOL_ATH_GYM_ATH]: menu.Gefsinus1,
    [SCHOOL_ATH_GYM_PSY]: menu.Gefsinus1,
    [SCHOOL_ATH_SEC]: menu.Gefsinus1,
    [SCHOOL_STC_LOWER]: menu.Gefsinus2,
    [SCHOOL_STC_UPPER]: menu.Gefsinus2,
    [SCHOOL_STC_SUMMER_CAMP_1]: menu.Gefsinus8,
    [SCHOOL_STC_SUMMER_CAMP_2]: menu.Gefsinus9,
    [SCHOOL_ACS_LOWER]: menu.Gefsinus3,
    [SCHOOL_ACS_UPPER]: menu.Gefsinus4,
    [SCHOOL_CAMPION]: menu.Gefsinus5,
    [SCHOOL_MORAITIS_LOWER]: menu.Gefsinus6,
    [SCHOOL_MORAITIS_UPPER]: menu.Gefsinus7,
    [SCHOOL_DES_PRIM]: menu.Demo,
    default: menu.Demo
}

// DailyMeals mapping - maps schools to their daily meals (non-menu meals)
// Separate from menu meals to allow different pricing and selection per school
export const dailyMealsMap: Record<string, string> = {
    [SCHOOL_LOCALHOST]: dailyMeals.Demo,
    [SCHOOL_DEMO]: dailyMeals.Demo,
    [SCHOOL_ATH_GYM_ATH]: dailyMeals.Ac,
    [SCHOOL_ATH_GYM_PSY]: dailyMeals.Ac,
    [SCHOOL_ATH_SEC]: dailyMeals.Ac,
    [SCHOOL_STC_LOWER]: dailyMeals.StcL,
    [SCHOOL_STC_UPPER]: dailyMeals.StcU,
    [SCHOOL_STC_SUMMER_CAMP_1]: dailyMeals.StcSC1,
    [SCHOOL_STC_SUMMER_CAMP_2]: dailyMeals.StcSC2,
    [SCHOOL_ACS_LOWER]: dailyMeals.AcsL,
    [SCHOOL_ACS_UPPER]: dailyMeals.AcsU,
    [SCHOOL_CAMPION]: dailyMeals.Campion,
    [SCHOOL_MORAITIS_LOWER]: dailyMeals.MoraitisL,
    [SCHOOL_MORAITIS_UPPER]: dailyMeals.MoraitisU,
    default: dailyMeals.Demo
}

export const domainMap: Record<string, { databaseURL: string }> = {
    [subDomainACSLower]: {
        databaseURL: 'https://lunchbox-acsl.europe-west1.firebasedatabase.app/'
    },
    [subDomainACSUpper]: {
        databaseURL: 'https://lunchbox-acsu.europe-west1.firebasedatabase.app/'
    },
    [subDomainAthensCollegeGymAthens]: {
        databaseURL: 'https://lunchbox-ac-gym.europe-west1.firebasedatabase.app/'
    },
    [subDomainAthensCollegeGymPsychico]: {
        databaseURL: 'https://lunchbox-ac-gympc.europe-west1.firebasedatabase.app/'
    },
    [subDomainAthensCollegeSecondary]: {
        databaseURL: 'https://lunchbox-ac-secondary.europe-west1.firebasedatabase.app/'
    },
    [subDomainStcLower]: {
        databaseURL: 'https://lunchbox-stcl.europe-west1.firebasedatabase.app/'
    },
    [subDomainStcUpper]: {
        databaseURL: 'https://lunchbox-stcu.europe-west1.firebasedatabase.app/'
    },
    [subDomainStcSummerCamp1]: {
        databaseURL: 'https://lunchbox-stcsc1.europe-west1.firebasedatabase.app/'
    },
    [subDomainStcSummerCamp2]: {
        databaseURL: 'https://lunchbox-stcsc2.europe-west1.firebasedatabase.app/'
    },
    [subDomainCampion]: {
        databaseURL: 'https://lunchbox-campion.europe-west1.firebasedatabase.app/'
    },
    [subDomainMoraitisLower]: {
        databaseURL: 'https://lunchbox-moraitis-l.europe-west1.firebasedatabase.app/'
    },
    [subDomainMoraitisUpper]: {
        databaseURL: 'https://lunchbox-moraitis-u.europe-west1.firebasedatabase.app/'
    },
    [subDomainDesPrimary]: {
        databaseURL: 'https://lunchbox-des-primary.europe-west1.firebasedatabase.app/'
    },
    [subDomainDemo]: {
        databaseURL: 'https://lunchbox-demo.europe-west1.firebasedatabase.app/'
    },
    localhost: {
        databaseURL: 'https://lunchbox-localhost.europe-west1.firebasedatabase.app/'
    },
    default: {
        databaseURL: 'https://lunchbox-main.europe-west1.firebasedatabase.app'
        // databaseURL: 'https://lunchbox-catering.firebaseio.com'
    }
}

export const gefsinusSchools = [SCHOOL_ACS_LOWER, SCHOOL_ACS_UPPER, SCHOOL_ATH_GYM_ATH, SCHOOL_ATH_GYM_PSY, SCHOOL_ATH_SEC, SCHOOL_STC_LOWER, SCHOOL_STC_UPPER, SCHOOL_STC_SUMMER_CAMP_1, SCHOOL_STC_SUMMER_CAMP_2, SCHOOL_CAMPION, SCHOOL_MORAITIS_LOWER, SCHOOL_MORAITIS_UPPER];

export const firebaseConfig = {
    apiKey: "AIzaSyAGQVf_xTxT8hIFVXIY8_aJFqrEVjJqMJw",
    // authDomain: "lunchbox-catering.firebaseapp.com",
    // authDomain: "athenscollege-secondary.lunch-box.gr",
    authDomain: "lunch-box.gr",
    projectId: "lunchbox-catering",
    storageBucket: "lunchbox-catering.appspot.com",
    messagingSenderId: "830353395689",
    appId: "1:830353395689:web:e217500e7ec85620d1c578",
    measurementId: "G-ZTPXB1D3GG",
    ...domainMap.default
};

